import { FC } from 'react'

import styled from 'styled-components'

import { ScheduleSummaryProps } from '..'

import { ScheduleSummaryTrackDetails } from './ScheduleSummaryTrackDetails'
import { ScheduleSummaryPriceDetails } from './ScheduleSummaryPriceDetails'
import { ScheduleSummaryPriceDetailsItem } from './ScheduleSummaryPriceDetails/ScheduleSummaryPriceDetailsItem'
import { ScheduleSummaryStartDateRow } from './ScheduleSummaryStartDateRow'
import { Divider } from './Divider'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`

const Total = styled(ScheduleSummaryPriceDetailsItem)`
  :first-child,
  :last-child {
    font-weight: 600;
  }
`

type Props = Omit<
  ScheduleSummaryProps,
  | 'onApplyPromocode'
  | 'onConfirm'
  | 'showPromocode'
  | 'showTooltip'
  | 'countdown'
  | 'paymentLoading'
  | 'tooltipType'
>
export const ScheduleSummaryDetails: FC<Props> = ({
  artistName,
  trackName,
  platform,
  price,
  total,
  vat,
  discount,
  balance,
  isBalanceHidden,
  matchingType,
  isPreRelease,
  trackCover,
  prioritizedLaunch,
  thresholdCoupon,
}) => (
  <Container>
    <ScheduleSummaryTrackDetails
      artistName={artistName}
      trackName={trackName}
      platform={platform}
      matchingType={matchingType}
      trackCover={trackCover}
      isPreRelease={isPreRelease}
    />
    <ScheduleSummaryPriceDetails
      price={price}
      vat={vat}
      discount={discount}
      balance={balance}
      isBalanceHidden={isBalanceHidden}
      discountLine={thresholdCoupon?.discountLine}
    />
    {prioritizedLaunch && (
      <ScheduleSummaryStartDateRow {...prioritizedLaunch} />
    )}
    <Divider data-testid='summary-divider' />
    <Total title='Total' price={total} />
  </Container>
)
